module.exports = __webpack_public_path__ + "media/images/logo-lucasistencia-60f8e9f1496ef61b60833b7f0a11b9fa.png";